import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaPsicologicaInterface } from "../../../../../interfaces/FechaPsicologicaInterface";
import { ConclusionLlenadaPSInterface } from "../../../../../interfaces/ConclusionLlenadaPSInterface";
import { ResultadoPSInterface } from "../../../../../interfaces/ResultadoPSInterface";
import { SemaforoPSInterface } from "../../../../../interfaces/SemaforoPSInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import SkyClear from "../../../../../img/SkyClear.png";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import { ConclusionesPSListaPrint } from "./ConclusionesPSListaPrint";

export const ConclusionesPSListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIONES DE EVALUACIÓN PSICOLÓGICA";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    visitDate: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const [selectedAdaptabilidad, setSelectedAdaptabilidad] = useState<
    string | null
  >(null);
  const [selectedResponsabilidad, setSelectedResponsabilidad] = useState<
    string | null
  >(null);
  const [selectedTrabajoEquipo, setSelectedTrabajoEquipo] = useState<
    string | null
  >(null);
  const [selectedTomaDecisiones, setSelectedTomaDecisiones] = useState<
    string | null
  >(null);
  const [selectedToleranciaPresion, setSelectedToleranciaPresion] = useState<
    string | null
  >(null);
  const [selectedCompromisoLaboral, setSelectedCompromisoLaboral] = useState<
    string | null
  >(null);
  const [selectedLiderazgo, setSelectedLiderazgo] = useState<string | null>(
    null
  );
  const [selectedIniciativa, setSelectedIniciativa] = useState<string | null>(
    null
  );
  const [selectedFortalezaYoica, setSelectedFortalezaYoica] = useState<
    string | null
  >(null);
  const [selectedToleranciaFrustracion, setSelectedToleranciaFrustracion] =
    useState<string | null>(null);
  const [selectedSeguridadSiMismo, setSelectedSeguridadSiMismo] = useState<
    string | null
  >(null);
  const [selectedControlImpulsos, setSelectedControlImpulsos] = useState<
    string | null
  >(null);
  const [
    selectedRelacionesInterpersonales,
    setSelectedRelacionesInterpersonales,
  ] = useState<string | null>(null);
  const [
    selectedInternalizacionNormasValores,
    setSelectedInternalizacionNormasValores,
  ] = useState<string | null>(null);
  const [selectedEstabilidadEmocional, setSelectedEstabilidadEmocional] =
    useState<string | null>(null);
  const [selectedContactoRealidad, setSelectedContactoRealidad] = useState<
    string | null
  >(null);
  const [selectedManejoEstres, setSelectedManejoEstres] = useState<
    string | null
  >(null);
  const [selectedAprendizajeMemoria, setSelectedAprendizajeMemoria] = useState<
    string | null
  >(null);
  const [selectedJuicioPractico, setSelectedJuicioPractico] = useState<
    string | null
  >(null);
  const [selectedPensamientoConcreto, setSelectedPensamientoConcreto] =
    useState<string | null>(null);
  const [selectedOrganizacionPlaneacion, setSelectedOrganizacionPlaneacion] =
    useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/domiciliaria/${evaluadosList_id}`);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaPS = useGetData<FechaPsicologicaInterface[]>({
    url: `/fecha_psico/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_psico"],
  });

  const queryConclusionPS = useGetData<ConclusionLlenadaPSInterface>({
    url: `/conclusionllenada_ps/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_ps"],
  });

  const queryResultadoPS = useGetData<ResultadoPSInterface[]>({
    url: `/resultado-conclusionps/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "resultado-conclusionps"],
  });

  const querySemaforoPS = useGetData<SemaforoPSInterface>({
    url: `/semaforoPS/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforoPS"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaPS.data && queryFechaPS.data.length > 0) {
      const fechaps = queryFechaPS.data[0];
      reset({
        fecha_conclusionps: fechaps.fecha_conclusionps || "",
      });
    }
  }, [queryFechaPS.data, reset]);

  useEffect(() => {
    if (querySemaforoPS.data) {
      const color = querySemaforoPS.data.color_ps || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_ps: color,
        evaluado_uuid: querySemaforoPS.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoPS.data, reset]);

  useEffect(() => {
    if (queryConclusionPS.data) {
      reset({
        conforma_ps: queryConclusionPS.data.conforma_ps || "",
        integrantes_ps: queryConclusionPS.data.integrantes_ps || "",
        identifica_ps: queryConclusionPS.data.identifica_ps || "",
        familiaporque_ps: queryConclusionPS.data.familiaporque_ps || "",
        relacionfam_ps: queryConclusionPS.data.relacionfam_ps || "",
        personalidad_ps: queryConclusionPS.data.personalidad_ps || "",
        describe_ps: queryConclusionPS.data.describe_ps || "",
        formaser_ps: queryConclusionPS.data.formaser_ps || "",
        personas_identificaps:
          queryConclusionPS.data.personas_identificaps || "",
        conocedrogas_ps: queryConclusionPS.data.conocedrogas_ps || "",
        consumealcohol_ps: queryConclusionPS.data.consumealcohol_ps || "",
        cuandoconsume_ps: queryConclusionPS.data.cuandoconsume_ps || "",
        procedimientosadm_ps: queryConclusionPS.data.procedimientosadm_ps || "",
        opinionpersona_ps: queryConclusionPS.data.opinionpersona_ps || "",
        mejor_ps: queryConclusionPS.data.mejor_ps || "",
        peor_ps: queryConclusionPS.data.peor_ps || "",
        motivoenojo_ps: queryConclusionPS.data.motivoenojo_ps || "",
        agredido_ps: queryConclusionPS.data.agredido_ps || "",
        riñaparticipo_ps: queryConclusionPS.data.riñaparticipo_ps || "",
        cualriña_ps: queryConclusionPS.data.cualriña_ps || "",
        estadoanimo_ps: queryConclusionPS.data.estadoanimo_ps || "",
        acontecimientotriste_ps:
          queryConclusionPS.data.acontecimientotriste_ps || "",
        tristezavida_ps: queryConclusionPS.data.tristezavida_ps || "",
        estadosalud_ps: queryConclusionPS.data.estadosalud_ps || "",
        tratamientomedico_ps: queryConclusionPS.data.tratamientomedico_ps || "",
        tratamientops_ps: queryConclusionPS.data.tratamientops_ps || "",
        motivo_ps: queryConclusionPS.data.motivo_ps || "",
        enterovacante_ps: queryConclusionPS.data.enterovacante_ps || "",
        problemasempresa_ps: queryConclusionPS.data.problemasempresa_ps || "",
        resolverproblemas_ps: queryConclusionPS.data.resolverproblemas_ps || "",
        reseñaempleos_ps: queryConclusionPS.data.reseñaempleos_ps || "",
        descripciongustatrabajo_ps:
          queryConclusionPS.data.descripciongustatrabajo_ps || "",
        descripciondisgustatrabajo_ps:
          queryConclusionPS.data.descripciondisgustatrabajo_ps || "",
        relacionjefecomp_ps: queryConclusionPS.data.relacionjefecomp_ps || "",
        situaciontrabajo_ps: queryConclusionPS.data.situaciontrabajo_ps || "",
        logropersonal_ps: queryConclusionPS.data.logropersonal_ps || "",
        logrolaboral_ps: queryConclusionPS.data.logrolaboral_ps || "",
        situacionimprevista_ps:
          queryConclusionPS.data.situacionimprevista_ps || "",
        tiempolibre_ps: queryConclusionPS.data.tiempolibre_ps || "",
        adaptacion_ps: queryConclusionPS.data.adaptacion_ps || "",
        manifiesta_ps: queryConclusionPS.data.manifiesta_ps || "",
        indicaacude_ps: queryConclusionPS.data.indicaacude_ps || "",
        adaptaequipo_psconforma_ps:
          queryConclusionPS.data.adaptaequipo_ps || "",
        tomadecision_ps: queryConclusionPS.data.tomadecision_ps || "",
        tolerancia_ps: queryConclusionPS.data.tolerancia_ps || "",
        compromiso_ps: queryConclusionPS.data.compromiso_ps || "",
        lider_ps: queryConclusionPS.data.lider_ps || "",
        ocasion_ps: queryConclusionPS.data.ocasion_ps || "",
        derivado2_ps: queryConclusionPS.data.derivado2_ps || "",
        objetivos_ps: queryConclusionPS.data.objetivos_ps || "",
        conseguirobj_ps: queryConclusionPS.data.conseguirobj_ps || "",
        observaciones_ps: queryConclusionPS.data.observaciones_ps || "",
        relaciones_interps: queryConclusionPS.data.relaciones_interps || "",
        adaptabilidad2_ps: queryConclusionPS.data.adaptabilidad2_ps || "",
        responsabilidad2_ps: queryConclusionPS.data.responsabilidad2_ps || "",
        trabajoequipo2_ps: queryConclusionPS.data.trabajoequipo2_ps || "",
        tomadecisiones2_ps: queryConclusionPS.data.tomadecisiones2_ps || "",
        toleranciapresion2_ps:
          queryConclusionPS.data.toleranciapresion2_ps || "",
        compromisolaboral2_ps:
          queryConclusionPS.data.compromisolaboral2_ps || "",
        liderazgo2_ps: queryConclusionPS.data.liderazgo2_ps || "",
        iniciativa2_ps: queryConclusionPS.data.iniciativa2_ps || "",
        fortalezayoica_ps: queryConclusionPS.data.fortalezayoica_ps || "",
        toleranciafrustracion_ps:
          queryConclusionPS.data.toleranciafrustracion_ps || "",
        seguridadsimismo_ps: queryConclusionPS.data.seguridadsimismo_ps || "",
        controlimpulsos_ps: queryConclusionPS.data.controlimpulsos_ps || "",
        relacionesinterpersonales_ps:
          queryConclusionPS.data.relacionesinterpersonales_ps || "",
        internalizacion_ps: queryConclusionPS.data.internalizacion_ps || "",
        estabilidademocional_ps:
          queryConclusionPS.data.estabilidademocional_ps || "",
        contactorealidad_ps: queryConclusionPS.data.contactorealidad_ps || "",
        manejoestres_ps: queryConclusionPS.data.manejoestres_ps || "",
        aprendizajememoria_ps:
          queryConclusionPS.data.aprendizajememoria_ps || "",
        juiciopractico_ps: queryConclusionPS.data.juiciopractico_ps || "",
        pensamientoconcreto_ps:
          queryConclusionPS.data.pensamientoconcreto_ps || "",
        organizacionplaneacion_ps:
          queryConclusionPS.data.organizacionplaneacion_ps || "",
        evaluado_uuid: queryConclusionPS.data.evaluado_uuid || "",
      });
      setSelectedAdaptabilidad(
        queryConclusionPS.data.adaptabilidad2_ps || null
      );
      setSelectedResponsabilidad(
        queryConclusionPS.data.responsabilidad2_ps || null
      );
      setSelectedTrabajoEquipo(
        queryConclusionPS.data.trabajoequipo2_ps || null
      );
      setSelectedTomaDecisiones(
        queryConclusionPS.data.tomadecisiones2_ps || null
      );
      setSelectedToleranciaPresion(
        queryConclusionPS.data.toleranciapresion2_ps || null
      );
      setSelectedCompromisoLaboral(
        queryConclusionPS.data.compromisolaboral2_ps || null
      );
      setSelectedLiderazgo(queryConclusionPS.data.liderazgo2_ps || null);
      setSelectedIniciativa(queryConclusionPS.data.iniciativa2_ps || null);
      setSelectedFortalezaYoica(
        queryConclusionPS.data.fortalezayoica_ps || null
      );
      setSelectedToleranciaFrustracion(
        queryConclusionPS.data.toleranciafrustracion_ps || null
      );
      setSelectedSeguridadSiMismo(
        queryConclusionPS.data.seguridadsimismo_ps || null
      );
      setSelectedControlImpulsos(
        queryConclusionPS.data.controlimpulsos_ps || null
      );
      setSelectedRelacionesInterpersonales(
        queryConclusionPS.data.relacionesinterpersonales_ps || null
      );
      setSelectedInternalizacionNormasValores(
        queryConclusionPS.data.internalizacion_ps || null
      );
      setSelectedEstabilidadEmocional(
        queryConclusionPS.data.estabilidademocional_ps || null
      );
      setSelectedContactoRealidad(
        queryConclusionPS.data.contactorealidad_ps || null
      );
      setSelectedManejoEstres(queryConclusionPS.data.manejoestres_ps || null);
      setSelectedAprendizajeMemoria(
        queryConclusionPS.data.aprendizajememoria_ps || null
      );
      setSelectedJuicioPractico(
        queryConclusionPS.data.juiciopractico_ps || null
      );
      setSelectedPensamientoConcreto(
        queryConclusionPS.data.pensamientoconcreto_ps || null
      );
      setSelectedOrganizacionPlaneacion(
        queryConclusionPS.data.organizacionplaneacion_ps || null
      );
    }
  }, [queryConclusionPS.data, reset]);

  useEffect(() => {
    if (queryResultadoPS.data && queryResultadoPS.data.length > 0) {
      const resultado = queryResultadoPS.data[0];
      reset({
        resultado_conclusion: resultado.resultado_conclusion || "",
      });
    }
  }, [queryResultadoPS.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
        <div className="grid grid-cols-3 gap-4">
            {/* Fecha Visita */}
            <div className="col-span-1 flex items-center">
                <Label htmlFor="fechaVisita" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    FECHA EVALUACIÓN:
                </Label>
                <Controller
                    name="fecha_conclusionps"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <input
                            id="fecha_conclusionps"
                            type="date"
                            value={
                                field.value ||
                                (queryFechaPS.data && queryFechaPS.data.length > 0
                                    ? queryFechaPS.data[0]?.fecha_conclusionps || ""
                                    : "")
                            }
                            onChange={(e) => field.onChange(e.target.value)}
                            disabled={true}
                            className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                        />
                    )}
                />
            </div>
            {/* Campo para nombre */}
            <div className="col-span-2">
                <Label htmlFor="nombre" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>NOMBRE:</Label>
                <TextInput
                    id="nombre"
                    name="nombre"
                    value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                    } ${queryEvaluado.data?.apellido_materno || ""}`}
                    onChange={handleInputChange}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>

            {/* FOTO */}
            <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-100 border-gray-300"}`}>
                {photoUrl ? (
                    <img
                        src={photoUrl}
                        alt="Foto de evaluado"
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <span className={isDarkMode ? "text-gray-400" : "text-gray-500"}>Sin foto disponible</span>
                )}
            </div>
            {/* SEMAFORO */}
            <div className="flex items-center gap-4">
                {/* Radio buttons */}
                <div className="flex flex-col">
                    <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                        <input
                            type="radio"
                            name="recommendation"
                            value="recomendable"
                            checked={selectedRecommendation === "recomendable"}
                            onChange={handleRadioChange}
                            disabled={true}
                            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}
                        />
                        RECOMENDABLE
                    </label>
                    <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                        <input
                            type="radio"
                            name="recommendation"
                            value="con_reserva"
                            checked={selectedRecommendation === "con_reserva"}
                            onChange={handleRadioChange}
                            disabled={true}
                            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}
                        />
                        CON RESERVA
                    </label>
                    <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                        <input
                            type="radio"
                            name="recommendation"
                            value="no_recomendable"
                            checked={selectedRecommendation === "no_recomendable"}
                            onChange={handleRadioChange}
                            disabled={true}
                            className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}
                        />
                        NO RECOMENDABLE
                    </label>
                </div>
                {/* Imagen de Semaforo */}
                <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
            </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
            {/* Campo para RFC */}
            <div className="col-span-1">
                <Label htmlFor="rfc" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>RFC:</Label>
                <TextInput
                    id="rfc"
                    name="rfc"
                    onChange={handleInputChange}
                    value={queryEvaluado.data?.rfc || ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Edad */}
            <div className="col-span-1">
                <Label htmlFor="edad" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>EDAD:</Label>
                <TextInput
                    id="edad"
                    name="edad"
                    value={edad !== null ? edad.toString() : ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Género */}
            <div className="col-span-1">
                <Label htmlFor="sexo" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>SEXO:</Label>
                <TextInput
                    id="sexo"
                    name="sexo"
                    onChange={handleInputChange}
                    value={queryEvaluado.data?.genero || ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Estado Civil */}
            <div className="col-span-1">
                <Label htmlFor="estadoCivil" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>ESTADO CIVIL:</Label>
                <TextInput
                    id="estadoCivil"
                    name="estadoCivil"
                    onChange={handleInputChange}
                    value={queryEvaluado.data?.estado_civil || ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Escolaridad */}
            <div className="col-span-1">
                <Label htmlFor="escolaridad" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>ESCOLARIDAD:</Label>
                <TextInput
                    id="escolaridad"
                    name="escolaridad"
                    onChange={handleInputChange}
                    value={queryEvaluado.data?.escolaridad || ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Fecha de Nacimiento */}
            <div className="col-span-1 flex items-center">
                <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    FECHA DE NACIMIENTO:
                </Label>
                <TextInput
                    id="fechaNacimiento"
                    name="fechaNacimiento"
                    value={queryEvaluado.data?.fecha_nacimiento || ""}
                    disabled={true}
                    type="date"
                    className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                />
            </div>
            {/* CURP */}
            <div className="col-span-1">
                <Label htmlFor="curp" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>CURP:</Label>
                <TextInput
                    id="curp"
                    name="curp"
                    onChange={handleInputChange}
                    value={queryEvaluado.data?.curp || ""}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
            {/* Empresa */}
            <div className="col-span-1">
                <Label htmlFor="empresa" className={isDarkMode ? "text-gray-200" : "text-gray-800"}>EMPRESA:</Label>
                <TextInput
                    id="empresa_id"
                    name="empresa"
                    value={queryEvaluado.data?.empresa_id?.nombre || ""}
                    onChange={handleInputChange}
                    disabled={true}
                    className={isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-800 border-gray-300"}
                />
            </div>
        </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIÓN PSICOLÓGICA
        </h2>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>CONCLUSIÓN</p>

        <div className="flex flex-col space-y-8">
          {/* Tabla COMPETENCIAS LABORALES */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-700" : "text-gray-800 border-gray-200"}`}>
                COMPETENCIAS LABORALES
            </h2>

            <div className="overflow-x-auto">
                <table className="w-full divide-y divide-gray-200">
                    <thead className={isDarkMode ? "bg-gray-700" : "bg-gray-50"}>
                        <tr>
                            <th
                                scope="col"
                                className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                            >
                                Competencia
                            </th>
                            <th
                                scope="col"
                                className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                            >
                                RECOMENDABLE
                            </th>
                            <th
                                scope="col"
                                className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                            >
                                CON RESERVA
                            </th>
                            <th
                                scope="col"
                                className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                            >
                                NO RECOMENDABLE
                            </th>
                        </tr>
                    </thead>
                    <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                        {/* Adaptabilidad */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                ADAPTABILIDAD
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="adaptabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="adaptabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="adaptabilidad2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedAdaptabilidad === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedAdaptabilidad("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="adaptabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="adaptabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="adaptabilidad2_ps"
                                            value="CON RESERVA"
                                            checked={selectedAdaptabilidad === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedAdaptabilidad("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="adaptabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="adaptabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="adaptabilidad2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedAdaptabilidad === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedAdaptabilidad("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Responsabilidad */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                RESPONSABILIDAD
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="responsabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="responsabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="responsabilidad2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedResponsabilidad === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedResponsabilidad("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="responsabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="responsabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="responsabilidad2_ps"
                                            value="CON RESERVA"
                                            checked={selectedResponsabilidad === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedResponsabilidad("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="responsabilidad2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="responsabilidad2_ps"
                                            type="radio"
                                            {...field}
                                            name="responsabilidad2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedResponsabilidad === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedResponsabilidad("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Trabajo en equipo */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                TRABAJO EN EQUIPO
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="trabajoequipo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="trabajoequipo2_ps"
                                            type="radio"
                                            {...field}
                                            name="trabajoequipo2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedTrabajoEquipo === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedTrabajoEquipo("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="trabajoequipo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="trabajoequipo2_ps"
                                            type="radio"
                                            {...field}
                                            name="trabajoequipo2_ps"
                                            value="CON RESERVA"
                                            checked={selectedTrabajoEquipo === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedTrabajoEquipo("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="trabajoequipo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="trabajoequipo2_ps"
                                            type="radio"
                                            {...field}
                                            name="trabajoequipo2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedTrabajoEquipo === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedTrabajoEquipo("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Toma de decisiones */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                TOMA DE DECISIONES
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="tomadecisiones2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="tomadecisiones2_ps"
                                            type="radio"
                                            {...field}
                                            name="tomadecisiones2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedTomaDecisiones === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedTomaDecisiones("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="tomadecisiones2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="tomadecisiones2_ps"
                                            type="radio"
                                            {...field}
                                            name="tomadecisiones2_ps"
                                            value="CON RESERVA"
                                            checked={selectedTomaDecisiones === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedTomaDecisiones("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="tomadecisiones2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="tomadecisiones2_ps"
                                            type="radio"
                                            {...field}
                                            name="tomadecisiones2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedTomaDecisiones === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedTomaDecisiones("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Tolerancia a la presión */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                TOLERANCIA A LA PRESIÓN
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="toleranciapresion2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="toleranciapresion2_ps"
                                            type="radio"
                                            {...field}
                                            name="toleranciapresion2_ps"
                                            value="RECOMENDABLE"
                                            checked={
                                                selectedToleranciaPresion === "RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedToleranciaPresion("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="toleranciapresion2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="toleranciapresion2_ps"
                                            type="radio"
                                            {...field}
                                            name="toleranciapresion2_ps"
                                            value="CON RESERVA"
                                            checked={
                                                selectedToleranciaPresion === "CON RESERVA"
                                            }
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedToleranciaPresion("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="toleranciapresion2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="toleranciapresion2_ps"
                                            type="radio"
                                            {...field}
                                            name="toleranciapresion2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedToleranciaPresion === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedToleranciaPresion("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Compromiso laboral */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                COMPROMISO LABORAL
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="compromisolaboral2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="compromisolaboral2_ps"
                                            type="radio"
                                            {...field}
                                            name="compromisolaboral2_ps"
                                            value="RECOMENDABLE"
                                            checked={
                                                selectedCompromisoLaboral === "RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedCompromisoLaboral("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="compromisolaboral2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="compromisolaboral2_ps"
                                            type="radio"
                                            {...field}
                                            name="compromisolaboral2_ps"
                                            value="CON RESERVA"
                                            checked={
                                                selectedCompromisoLaboral === "CON RESERVA"
                                            }
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedCompromisoLaboral("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="compromisolaboral2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="compromisolaboral2_ps"
                                            type="radio"
                                            {...field}
                                            name="compromisolaboral2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={
                                                selectedCompromisoLaboral === "NO RECOMENDABLE"
                                            }
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedCompromisoLaboral("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Liderazgo */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                LIDERAZGO
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="liderazgo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="liderazgo2_ps"
                                            type="radio"
                                            {...field}
                                            name="liderazgo2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedLiderazgo === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedLiderazgo("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="liderazgo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="liderazgo2_ps"
                                            type="radio"
                                            {...field}
                                            name="liderazgo2_ps"
                                            value="CON RESERVA"
                                            checked={selectedLiderazgo === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedLiderazgo("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="liderazgo2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="liderazgo2_ps"
                                            type="radio"
                                            {...field}
                                            name="liderazgo2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={selectedLiderazgo === "NO RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedLiderazgo("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>

                        {/* Iniciativa */}
                        <tr>
                            <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                                INICIATIVA
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="iniciativa2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="iniciativa2_ps"
                                            type="radio"
                                            {...field}
                                            name="iniciativa2_ps"
                                            value="RECOMENDABLE"
                                            checked={selectedIniciativa === "RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("RECOMENDABLE");
                                                setSelectedIniciativa("RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="iniciativa2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="iniciativa2_ps"
                                            type="radio"
                                            {...field}
                                            name="iniciativa2_ps"
                                            value="CON RESERVA"
                                            checked={selectedIniciativa === "CON RESERVA"}
                                            onChange={() => {
                                                field.onChange("CON RESERVA");
                                                setSelectedIniciativa("CON RESERVA");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                            <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                <Controller
                                    name="iniciativa2_ps"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <input
                                            id="iniciativa2_ps"
                                            type="radio"
                                            {...field}
                                            name="iniciativa2_ps"
                                            value="NO RECOMENDABLE"
                                            checked={selectedIniciativa === "NO RECOMENDABLE"}
                                            onChange={() => {
                                                field.onChange("NO RECOMENDABLE");
                                                setSelectedIniciativa("NO RECOMENDABLE");
                                            }}
                                            disabled={true}
                                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                        />
                                    )}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </div>

          {/* Tabla PERSONALIDAD */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-800 border-gray-200"}`}>
              PERSONALIDAD
            </h2>

            <div className="overflow-x-auto">
              <table className={`w-full divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                <thead className={isDarkMode ? "bg-gray-700" : "bg-gray-50"}>
                    <tr>
                        <th
                            scope="col"
                            className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                        >
                            Competencia
                        </th>
                        <th
                            scope="col"
                            className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                        >
                            RECOMENDABLE
                        </th>
                        <th
                            scope="col"
                            className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                        >
                            CON RESERVA
                        </th>
                        <th
                            scope="col"
                            className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-300" : "text-gray-500"}`}
                        >
                            NO RECOMENDABLE
                        </th>
                    </tr>
                </thead>
                <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                  {/* Fortaleza Yoica */}
                  <tr>
                      <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                          FORTALEZA YOICA
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="fortalezayoica_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="fortalezayoica_ps"
                                      type="radio"
                                      {...field}
                                      name="fortalezayoica_ps"
                                      value="RECOMENDABLE"
                                      checked={selectedFortalezaYoica === "RECOMENDABLE"}
                                      onChange={() => {
                                          field.onChange("RECOMENDABLE");
                                          setSelectedFortalezaYoica("RECOMENDABLE");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="fortalezayoica_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="fortalezayoica_ps"
                                      type="radio"
                                      {...field}
                                      name="fortalezayoica_ps"
                                      value="CON RESERVA"
                                      checked={selectedFortalezaYoica === "CON RESERVA"}
                                      onChange={() => {
                                          field.onChange("CON RESERVA");
                                          setSelectedFortalezaYoica("CON RESERVA");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="fortalezayoica_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="fortalezayoica_ps"
                                      type="radio"
                                      {...field}
                                      name="fortalezayoica_ps"
                                      value="NO RECOMENDABLE"
                                      checked={
                                          selectedFortalezaYoica === "NO RECOMENDABLE"
                                      }
                                      onChange={() => {
                                          field.onChange("NO RECOMENDABLE");
                                          setSelectedFortalezaYoica("NO RECOMENDABLE");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                  </tr>

                  {/* Tolerancia a la Frustración */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        TOLERANCIA A LA FRUSTRACIÓN
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="toleranciafrustracion_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="toleranciafrustracion_ps"
                                    type="radio"
                                    {...field}
                                    name="toleranciafrustracion_ps"
                                    value="RECOMENDABLE"
                                    checked={
                                        selectedToleranciaFrustracion === "RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedToleranciaFrustracion("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="toleranciafrustracion_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="toleranciafrustracion_ps"
                                      type="radio"
                                      {...field}
                                      name="toleranciafrustracion_ps"
                                      value="CON RESERVA"
                                      checked={
                                          selectedToleranciaFrustracion === "CON RESERVA"
                                      }
                                      onChange={() => {
                                          field.onChange("CON RESERVA");
                                          setSelectedToleranciaFrustracion("CON RESERVA");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="toleranciafrustracion_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="toleranciafrustracion_ps"
                                      type="radio"
                                      {...field}
                                      name="toleranciafrustracion_ps"
                                      value="NO RECOMENDABLE"
                                      checked={
                                          selectedToleranciaFrustracion === "NO RECOMENDABLE"
                                      }
                                      onChange={() => {
                                          field.onChange("NO RECOMENDABLE");
                                          setSelectedToleranciaFrustracion(
                                              "NO RECOMENDABLE"
                                          );
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                  </tr>

                  {/* Seguridad en sí mismo */}
                  <tr>
                      <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                          SEGURIDAD EN SÍ MISMO
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="seguridadsimismo_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="seguridadsimismo_ps"
                                      type="radio"
                                      {...field}
                                      name="seguridadsimismo_ps"
                                      value="RECOMENDABLE"
                                      checked={selectedSeguridadSiMismo === "RECOMENDABLE"}
                                      onChange={() => {
                                          field.onChange("RECOMENDABLE");
                                          setSelectedSeguridadSiMismo("RECOMENDABLE");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="seguridadsimismo_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="seguridadsimismo_ps"
                                      type="radio"
                                      {...field}
                                      name="seguridadsimismo_ps"
                                      value="CON RESERVA"
                                      checked={selectedSeguridadSiMismo === "CON RESERVA"}
                                      onChange={() => {
                                          field.onChange("CON RESERVA");
                                          setSelectedSeguridadSiMismo("CON RESERVA");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                      <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                          <Controller
                              name="seguridadsimismo_ps"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                  <input
                                      id="seguridadsimismo_ps"
                                      type="radio"
                                      {...field}
                                      name="seguridadsimismo_ps"
                                      value="NO RECOMENDABLE"
                                      checked={selectedSeguridadSiMismo === "NO RECOMENDABLE"}
                                      onChange={() => {
                                          field.onChange("NO RECOMENDABLE");
                                          setSelectedSeguridadSiMismo("NO RECOMENDABLE");
                                      }}
                                      disabled={true}
                                      className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                  />
                              )}
                          />
                      </td>
                  </tr>

                  {/* Control de Impulsos */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        CONTROL DE IMPULSOS
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="controlimpulsos_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="controlimpulsos_ps"
                                    type="radio"
                                    {...field}
                                    name="controlimpulsos_ps"
                                    value="RECOMENDABLE"
                                    checked={selectedControlImpulsos === "RECOMENDABLE"}
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedControlImpulsos("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="control_impulsops"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="control_impulsops"
                                    type="radio"
                                    {...field}
                                    name="control_impulsops"
                                    value="CON RESERVA"
                                    checked={selectedControlImpulsos === "CON RESERVA"}
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedControlImpulsos("CON RESERVA");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="control_impulsops"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="control_impulsops"
                                    type="radio"
                                    {...field}
                                    name="control_impulsops"
                                    value="NO RECOMENDABLE"
                                    checked={
                                        selectedControlImpulsos === "NO RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedControlImpulsos("NO RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>

                  {/* Relaciones Interpersonales */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        RELACIONES INTERPERSONALES
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="relacionesinterpersonales_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="relacionesinterpersonales_ps"
                                    type="radio"
                                    {...field}
                                    name="relacionesinterpersonales_ps"
                                    value="RECOMENDABLE"
                                    checked={
                                        selectedRelacionesInterpersonales ===
                                        "RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedRelacionesInterpersonales(
                                            "RECOMENDABLE"
                                        );
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="relacionesinterpersonales_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="relacionesinterpersonales_ps"
                                    type="radio"
                                    {...field}
                                    name="relacionesinterpersonales_ps"
                                    value="CON RESERVA"
                                    checked={
                                        selectedRelacionesInterpersonales ===
                                        "CON RESERVA"
                                    }
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedRelacionesInterpersonales(
                                            "CON RESERVA"
                                        );
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="relacionesinterpersonales_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="relacionesinterpersonales_ps"
                                    type="radio"
                                    {...field}
                                    name="relacionesinterpersonales_ps"
                                    value="NO RECOMENDABLE"
                                    checked={
                                        selectedRelacionesInterpersonales ===
                                        "NO RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedRelacionesInterpersonales(
                                            "NO RECOMENDABLE"
                                        );
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>

                  {/* Internalización Normas y Valores */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        INTERNALIZACIÓN NORMAS Y VALORES
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="internalizacion_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="internalizacion_ps"
                                    type="radio"
                                    {...field}
                                    name="internalizacion_ps"
                                    value="RECOMENDABLE"
                                    checked={
                                        selectedInternalizacionNormasValores === "RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedInternalizacionNormasValores("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="internalizacion_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="internalizacion_ps"
                                    type="radio"
                                    {...field}
                                    name="internalizacion_ps"
                                    value="CON RESERVA"
                                    checked={
                                        selectedInternalizacionNormasValores === "CON RESERVA"
                                    }
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedInternalizacionNormasValores("CON RESERVA");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="internalizacion_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="internalizacion_ps"
                                    type="radio"
                                    {...field}
                                    name="internalizacion_ps"
                                    value="NO RECOMENDABLE"
                                    checked={
                                        selectedInternalizacionNormasValores === "NO RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedInternalizacionNormasValores("NO RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>

                  {/* Estabilidad Emocional */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        ESTABILIDAD EMOCIONAL
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="estabilidademocional_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="estabilidademocional_ps"
                                    type="radio"
                                    {...field}
                                    name="estabilidademocional_ps"
                                    value="RECOMENDABLE"
                                    checked={
                                        selectedEstabilidadEmocional === "RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedEstabilidadEmocional("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="estabilidademocional_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="estabilidademocional_ps"
                                    type="radio"
                                    {...field}
                                    name="estabilidademocional_ps"
                                    value="CON RESERVA"
                                    checked={
                                        selectedEstabilidadEmocional === "CON RESERVA"
                                    }
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedEstabilidadEmocional("CON RESERVA");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="estabilidademocional_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="estabilidademocional_ps"
                                    type="radio"
                                    {...field}
                                    name="estabilidademocional_ps"
                                    value="NO RECOMENDABLE"
                                    checked={
                                        selectedEstabilidadEmocional === "NO RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedEstabilidadEmocional(
                                            "NO RECOMENDABLE"
                                        );
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>

                  {/* Contacto con la realidad */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        CONTACTO CON LA REALIDAD
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="contactorealidad_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="contactorealidad_ps"
                                    type="radio"
                                    {...field}
                                    name="contactorealidad_ps"
                                    value="RECOMENDABLE"
                                    checked={
                                        selectedContactoRealidad === "RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedContactoRealidad("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="contactorealidad_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="contactorealidad_ps"
                                    type="radio"
                                    {...field}
                                    name="contactorealidad_ps"
                                    value="CON RESERVA"
                                    checked={selectedContactoRealidad === "CON RESERVA"}
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedContactoRealidad("CON RESERVA");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="contactorealidad_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="contactorealidad_ps"
                                    type="radio"
                                    {...field}
                                    name="contactorealidad_ps"
                                    value="NO RECOMENDABLE"
                                    checked={
                                        selectedContactoRealidad === "NO RECOMENDABLE"
                                    }
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedContactoRealidad("NO RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>

                  {/* Manejo del Estrés */}
                  <tr>
                    <td className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
                        MANEJO DEL ESTRÉS
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="manejoestres_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="manejoestres_ps"
                                    type="radio"
                                    {...field}
                                    name="manejoestres_ps"
                                    value="RECOMENDABLE"
                                    checked={selectedManejoEstres === "RECOMENDABLE"}
                                    onChange={() => {
                                        field.onChange("RECOMENDABLE");
                                        setSelectedManejoEstres("RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="manejoestres_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="manejoestres_ps"
                                    type="radio"
                                    {...field}
                                    name="manejoestres_ps"
                                    value="CON RESERVA"
                                    checked={selectedManejoEstres === "CON RESERVA"}
                                    onChange={() => {
                                        field.onChange("CON RESERVA");
                                        setSelectedManejoEstres("CON RESERVA");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                        <Controller
                            name="manejoestres_ps"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                                <input
                                    id="manejoestres_ps"
                                    type="radio"
                                    {...field}
                                    name="manejoestres_ps"
                                    value="NO RECOMENDABLE"
                                    checked={selectedManejoEstres === "NO RECOMENDABLE"}
                                    onChange={() => {
                                        field.onChange("NO RECOMENDABLE");
                                        setSelectedManejoEstres("NO RECOMENDABLE");
                                    }}
                                    disabled={true}
                                    className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300"}`}
                                />
                            )}
                        />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tabla ESFERA INTELECTUAL */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
              <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-600" : "text-gray-800 border-gray-200"}`}>
                  ESFERA INTELECTUAL
              </h2>

              <div className="overflow-x-auto">
                  <table className={`w-full divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                      <thead className={isDarkMode ? "bg-gray-700" : "bg-gray-50"}>
                          <tr>
                              <th
                                  scope="col"
                                  className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                                      isDarkMode ? "text-gray-300" : "text-gray-500"
                                  }`}
                              >
                                  Competencia
                              </th>
                              <th
                                  scope="col"
                                  className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${
                                      isDarkMode ? "text-gray-300" : "text-gray-500"
                                  }`}
                              >
                                  RECOMENDABLE
                              </th>
                              <th
                                  scope="col"
                                  className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${
                                      isDarkMode ? "text-gray-300" : "text-gray-500"
                                  }`}
                              >
                                  CON RESERVA
                              </th>
                              <th
                                  scope="col"
                                  className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${
                                      isDarkMode ? "text-gray-300" : "text-gray-500"
                                  }`}
                              >
                                  NO RECOMENDABLE
                              </th>
                          </tr>
                      </thead>
                      <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                          {/* Aprendizaje y Memoria */}
                          <tr>
                              <td
                                  className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${
                                      isDarkMode ? "text-gray-200" : "text-gray-900"
                                  }`}
                              >
                                  APRENDIZAJE Y MEMORIA
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="aprendizajememoria_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="aprendizajememoria_ps"
                                              type="radio"
                                              {...field}
                                              name="aprendizajememoria_ps"
                                              value="RECOMENDABLE"
                                              checked={
                                                  selectedAprendizajeMemoria ===
                                                  "RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("RECOMENDABLE");
                                                  setSelectedAprendizajeMemoria("RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="aprendizajememoria_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="aprendizajememoria_ps"
                                              type="radio"
                                              {...field}
                                              name="aprendizajememoria_ps"
                                              value="CON RESERVA"
                                              checked={
                                                  selectedAprendizajeMemoria ===
                                                  "CON RESERVA"
                                              }
                                              onChange={() => {
                                                  field.onChange("CON RESERVA");
                                                  setSelectedAprendizajeMemoria("CON RESERVA");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="aprendizajememoria_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="aprendizajememoria_ps"
                                              type="radio"
                                              {...field}
                                              name="aprendizajememoria_ps"
                                              value="NO RECOMENDABLE"
                                              checked={
                                                  selectedAprendizajeMemoria ===
                                                  "NO RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("NO RECOMENDABLE");
                                                  setSelectedAprendizajeMemoria("NO RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                          </tr>

                          {/* Juicio Práctico */}
                          <tr>
                              <td
                                  className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${
                                      isDarkMode ? "text-gray-200" : "text-gray-900"
                                  }`}
                              >
                                  JUICIO PRÁCTICO
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="juiciopractico_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="juiciopractico_ps"
                                              type="radio"
                                              {...field}
                                              name="juiciopractico_ps"
                                              value="RECOMENDABLE"
                                              checked={selectedJuicioPractico === "RECOMENDABLE"}
                                              onChange={() => {
                                                  field.onChange("RECOMENDABLE");
                                                  setSelectedJuicioPractico("RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="juiciopractico_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="juiciopractico_ps"
                                              type="radio"
                                              {...field}
                                              name="juiciopractico_ps"
                                              value="CON RESERVA"
                                              checked={selectedJuicioPractico === "CON RESERVA"}
                                              onChange={() => {
                                                  field.onChange("CON RESERVA");
                                                  setSelectedJuicioPractico("CON RESERVA");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="juiciopractico_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="juiciopractico_ps"
                                              type="radio"
                                              {...field}
                                              name="juiciopractico_ps"
                                              value="NO RECOMENDABLE"
                                              checked={
                                                  selectedJuicioPractico === "NO RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("NO RECOMENDABLE");
                                                  setSelectedJuicioPractico("NO RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                          </tr>

                          {/* Pensamiento Concreto */}
                          <tr>
                              <td
                                  className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${
                                      isDarkMode ? "text-gray-200" : "text-gray-900"
                                  }`}
                              >
                                  PENSAMIENTO CONCRETO
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="pensamientoconcreto_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="pensamientoconcreto_ps"
                                              type="radio"
                                              {...field}
                                              name="pensamientoconcreto_ps"
                                              value="RECOMENDABLE"
                                              checked={
                                                  selectedPensamientoConcreto === "RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("RECOMENDABLE");
                                                  setSelectedPensamientoConcreto("RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="pensamientoconcreto_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="pensamientoconcreto_ps"
                                              type="radio"
                                              {...field}
                                              name="pensamientoconcreto_ps"
                                              value="CON RESERVA"
                                              checked={
                                                  selectedPensamientoConcreto === "CON RESERVA"
                                              }
                                              onChange={() => {
                                                  field.onChange("CON RESERVA");
                                                  setSelectedPensamientoConcreto("CON RESERVA");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="pensamientoconcreto_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="pensamientoconcreto_ps"
                                              type="radio"
                                              {...field}
                                              name="pensamientoconcreto_ps"
                                              value="NO RECOMENDABLE"
                                              checked={
                                                  selectedPensamientoConcreto === "NO RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("NO RECOMENDABLE");
                                                  setSelectedPensamientoConcreto("NO RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                          </tr>

                          {/* Organización y Planeación */}
                          <tr>
                              <td
                                  className={`w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left ${
                                      isDarkMode ? "text-gray-200" : "text-gray-900"
                                  }`}
                              >
                                  Organización y Planeación
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="organizacionplaneacion_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="organizacionplaneacion_ps"
                                              type="radio"
                                              {...field}
                                              name="organizacionplaneacion_ps"
                                              value="RECOMENDABLE"
                                              checked={
                                                  selectedOrganizacionPlaneacion === "RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("RECOMENDABLE");
                                                  setSelectedOrganizacionPlaneacion("RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="organizacionplaneacion_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="organizacionplaneacion_ps"
                                              type="radio"
                                              {...field}
                                              name="organizacionplaneacion_ps"
                                              value="CON RESERVA"
                                              checked={
                                                  selectedOrganizacionPlaneacion === "CON RESERVA"
                                              }
                                              onChange={() => {
                                                  field.onChange("CON RESERVA");
                                                  setSelectedOrganizacionPlaneacion("CON RESERVA");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                              <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                                  <Controller
                                      name="organizacionplaneacion_ps"
                                      control={control}
                                      defaultValue=""
                                      render={({ field }) => (
                                          <input
                                              id="organizacionplaneacion_ps"
                                              type="radio"
                                              {...field}
                                              name="organizacionplaneacion_ps"
                                              value="NO RECOMENDABLE"
                                              checked={
                                                  selectedOrganizacionPlaneacion === "NO RECOMENDABLE"
                                              }
                                              onChange={() => {
                                                  field.onChange("NO RECOMENDABLE");
                                                  setSelectedOrganizacionPlaneacion("NO RECOMENDABLE");
                                              }}
                                              disabled={true}
                                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${
                                                  isDarkMode
                                                      ? "border-gray-600 bg-gray-700"
                                                      : "border-gray-300"
                                              }`}
                                          />
                                      )}
                                  />
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
        </div>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Derivado de la valoriación y revisión de la información, se considera
            que es una{" "}
            <strong>
                PERSONA
            </strong>{" "}
            <strong>{queryConclusionPS.data?.habitos_ps}</strong>, en virtud de que
            al momento de la evaluación psicológica, se detectó que:
            <Controller
                name="relaciones_interps"
                control={control}
                defaultValue={`${
                    queryConclusionPS.data?.relaciones_interps || ""
                }`}
                render={({ field }) => {
                    return (
                        <textarea
                            {...field}
                            id="relaciones_interps"
                            disabled={true}
                            className={`w-full p-4 min-h-[150px] text-sm rounded-lg border-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${
                                isDarkMode
                                    ? "text-gray-200 border-gray-600 placeholder-gray-500 bg-gray-700"
                                    : "text-gray-900 border-gray-300 placeholder-gray-400"
                            }`}
                            aria-label="relaciones_interps"
                            placeholder="Escribe lo que detectarón aquí..."
                        />
                    );
                }}
            />
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Se procedió a la revisión minuciosa de todos y cada uno de los
            documentos que el candidato exhibió, los siguientes:
        </p>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              AMBITO FAMILIAR
          </p>

          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <span className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                  {`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
              </span>{" "}
              refiere ser{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryEvaluado.data?.estado_civil || ""}`}
              </span>
              , su familia se conforma de{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.conforma_ps || ""}`}
              </span>{" "}
              integrantes{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.integrantes_ps || ""}`}
              </span>
              . Comenta que se identifica con{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.identifica_ps || ""}`}
              </span>{" "}
              de su familia porque{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.familiaporque_ps || ""}`}
              </span>
              .
          </p>

          <p
              className={`text-justify leading-relaxed ${
                  isDarkMode ? "text-gray-200" : "text-gray-800"
              }`}
          >
              Menciona que la relación con su familia es{" "}
              <span
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.relacionfam_ps || ""}`}
              </span>
              .
          </p>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
          <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}          >
              PERSONALIDAD
          </p>

          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
              </label>{" "}
              es{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.personalidad_ps || ""}`}
              </label>{" "}
              y se describe como{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {`${queryConclusionPS.data?.describe_ps || ""}`}
              </label>
              .
          </p>
          <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              Reseña que lo que más le han criticado de su forma de ser es{" "}
              <label
                  htmlFor="nombre"
                  className={`font-medium inline-block ${
                      isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
              >
                  {queryConclusionPS.data?.formaser_ps || ""}
              </label>
              .
          </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          RELACIONES INTERPERSONALES
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Explica que las personas con las que se identifica son{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.personas_identificaps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>HÁBITOS</p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Refiera que{" "}
          <label htmlFor="conocedrogas_ps" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {queryConclusionPS.data?.conocedrogas_ps === true ? "Sí" : queryConclusionPS.data?.conocedrogas_ps === false ? "No" : ""}
          </label>{" "}
          conoce drogas y que{" "}
          <label htmlFor="conocedrogas_ps" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {queryConclusionPS.data?.consumealcohol_ps === true ? "Sí" : queryConclusionPS.data?.consumealcohol_ps === false ? "No" : ""}
          </label>{" "}
          consume alcohol cuando{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.cuandoconsume_ps || ""}.`}
          </label>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          APEGO A NORMAS Y VALORES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Comenta que{" "}
          <label htmlFor="conocedrogas_ps" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {queryConclusionPS.data?.procedimientosadm_ps === true
              ? "Sí"
              : queryConclusionPS.data?.procedimientosadm_ps === false
              ? "No"
              : ""}
          </label>{" "}
          tiene procedimientos administrativos y/o jurídicos. También menciona
          que sus jefes y maestros opinan que es una persona{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.opinionpersona_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Nos cuenta que lo mejor que ha hecho hasta el día de hoy es{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.mejor_ps || ""}`}
          </label>{" "}
          y que lo peor que ha hecho al día de hoy es{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.peor_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            CONTROL DE IMPULSOS
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Explica que los motivos por los que se enoja son:
        </p>
        <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.motivoenojo_ps || ""}`}
        </label>
        <p>
            y que cuando es agredido reacciona{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {`${queryConclusionPS.data?.agredido_ps || ""}`}
            </label>
            .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            ¿Participó en riñas?{" "}
            <label htmlFor="conocedrogas_ps" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {queryConclusionPS.data?.riñaparticipo_ps === true
                    ? "Sí"
                    : queryConclusionPS.data?.riñaparticipo_ps === false
                    ? "No"
                    : ""}
            </label>
            , la última riña en la que participó fue{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {`${queryConclusionPS.data?.cualriña_ps || ""}`}
            </label>{" "}
            .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Refiera que su estado de ánimo actual es{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {`${queryConclusionPS.data?.estadoanimo_ps || ""}`}
            </label>
            .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            El acontecimiento más triste que ha vivido es{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {`${queryConclusionPS.data?.acontecimientotriste_ps || ""}`}
            </label>{" "}
            y que la tristeza en su vida se refleja{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                {`${queryConclusionPS.data?.tristezavida_ps || ""}`}
            </label>
            .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>SALUD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Durante la entrevista señaló que considera su estado de salud{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.estadosalud_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ENFERMEDADES</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Que ha llevado o cuenta con{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.tratamientomedico_ps || ""}`}
          </label>{" "}
          tratamiento médico prolongado derivado de{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.derivado1_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Tratamiento psicológico o psiquiátrico, refiere{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.tratamientops_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ÁMBITO LABORAL</p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le cuestionó al evaluado el motivo por el que entró a trabajar a la
          empresa y refirió que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.motivo_ps || ""}`}
          </label>
          .
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También que se enteró de la vacante por{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.enterovacante_ps || ""}`}
          </label>
          .
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le preguntó también su opinión de los problemas que se pueden
          presentar en la empresa y al respecto dijo que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.problemasempresa_ps || ""}`}
          </label>
          , asimismo menciona que puede contribuir a resolverlos{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.resolverproblemas_ps || ""}`}
          </label>
          .
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Reseña de sus empleos anteriores{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.reseñaempleos_ps || ""}`}
          </label>
          .
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Realizó la siguiente descripción de lo que más le gusta de su último
            trabajo:{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              {`${queryConclusionPS.data?.descripciongustatrabajo_ps || ""}`}
            </label>
          </p>
        </div>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            También explicó lo que menos le gustaba de su último trabajo:{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              {`${queryConclusionPS.data?.descripciondisgustatrabajo_ps || ""}`}
            </label>
          </p>
        </div>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que la relación con sus jefes y compañeros ha sido{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.relacionjefecomp_ps || ""}`}
          </label>
          . Y que la situación más difícil que ha enfrentado en el trabajo es{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.situaciontrabajo_ps || ""}`}
          </label>
          .
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            El evaluado explicó que su mayor logro personal y laboral son:{" "}
            <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              {`${queryConclusionPS.data?.logropersonal_ps || ""}`}
            </label>
          </p>
        </div>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También refirió que en una situación imprevista o bajo presión en la
          que tuvo que tomar decisiones, actuó{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.situacionimprevista_ps || ""}`}
          </label>{" "}
          y el resultado que obtuvo.{" "}
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          ACTIVIDADES EN LOS TIEMPOS LIBRES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          El evaluado explica que las actividades que realiza en los tiempos
          libres son{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.tiempolibre_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          COMPETENCIAS LABORALES
        </p>

        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ADAPTABILIDAD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.adaptacion_ps || ""}`}
          </label>{" "}
          se adapta a nuevas actividades y a los cambios laborales como
          sociales.
        </p>

        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RESPONSABILIDAD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Manifiesta que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.manifiesta_ps || ""}`}
          </label>{" "}
          con la entrega de trabajos el día y hora que se requieren.
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Indica que acude{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.indicaacude_ps || ""}`}
          </label>{" "}
          a trabajar en los horarios establecidos de manera puntual.
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>TRABAJO EN EQUIPO</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le cuestionó con qué facilidad se le adapta a trabajar en equipo y
          mencionó que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.adaptaequipo_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          TOMA DE DECISIONES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También señala que en situaciones de emergencia en sus actividades
          laborales toma decisiones{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.tomadecision_ps || ""}`}
          </label>{" "}
          para solucionar el conflicto.
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          TOLERANCIA A LA PRESIÓN
        </p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tolerancia_ps || ""}`}
          </label>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          COMPROMISO LABORAL
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            El evaluado mencionó que:{" "}
            <label
              htmlFor="nombre"
              className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
            >
              {`${queryConclusionPS.data?.compromiso_ps || ""}`}
            </label>
          </p>
        </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>LIDERAZGO</p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.lider_ps || ""}`}
          </label>
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>INICIATIVA</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          El evaluado manifiesta que en{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.ocasion_ps || ""}`}
          </label>{" "}
          tuvo que asumir mayor responsabilidad en su lugar de trabajo que lo
          que le correspondía hacer, derivado de que{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.derivado2_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que sus objetivos inmediatos son{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.objetivos_ps || ""}`}
          </label>{" "}
          y para conseguirlos hace{" "}
          <label htmlFor="nombre" className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            {`${queryConclusionPS.data?.conseguirobj_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          CONDUCTA EN EL EXAMEN
        </p>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Al momento de realizar la evaluación, mencionó estar en buen estado de
          salud, psicológico y emocional para llevar a cabo la evaluación, por
          lo que durante la entrevista manifestó entender de manera clara y
          oportuna los cuestionamientos que se le realizaron; cabe señalar que
          durante el examen aseveró presentarse de manera voluntaria asentado su
          consentimiento mediante la firma del formato de autorización, aunado a
          lo anterior acató de manera clara y precisa las indicaciones que se le
          proporcionaron, por lo que la prueba se concluyó sin problema alguno.{" "}
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-50"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>OBSERVACIONES</p>
        <label
          htmlFor="nombre"
          className={`text-justify font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
        >
          {`${queryConclusionPS.data?.observaciones_ps || ""}`}
        </label>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
            <Label
                htmlFor="rfc"
                className={`${isDarkMode ? "text-gray-200" : "text-gray-900"}`}
            >
                RESULTADO:
            </Label>
            <Controller
                name="resultado_conclusion"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <TextInput
                        id="resultado_conclusion"
                        type="text"
                        value={
                            field.value ||
                            (queryResultadoPS.data && queryResultadoPS.data.length > 0
                                ? queryResultadoPS.data[0]?.resultado_conclusion || ""
                                : "")
                        }
                        disabled={true}
                        onChange={(e) => field.onChange(e.target.value)}
                        className={`text-center w-full ${isDarkMode ? "bg-gray-800 text-gray-200 border-gray-600 placeholder-gray-500 focus:ring-blue-500 focus:border-blue-500" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                    />
                )}
            />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white"}`}
          onSubmit={handleSubmit}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar en renderPage1 (lado izquierdo) */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/psicologica/${evaluadosList_id}`);
                }}
                className={`text-white rounded ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800" : "bg-red-500"}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente en renderPage1 (lado derecho) */}
            {currentPage === 1 && (
              <Button
                type="button"
                className={`text-white rounded ml-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-800" : "bg-blue-400"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-violet-600 hover:bg-violet-800 text-white" : "bg-violet-400"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  color="blue"
                  onClick={handlePrint}
                  className={`ml-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-800 text-white" : "bg-blue-500"}`}
                >
                  Imprimir
                </Button>
                <Button
                  className={`text-white rounded ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800" : "bg-red-500"}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/psicologica/${evaluadosList_id}`);
                  }}
                >
                  Salir
                </Button>
              </div>
            )}
          </div>
        </form>
        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <ConclusionesPSListaPrint />
        </div>
      </div>
    </div>
  );
};
